<template>
  <v-row no-gutters class="pa-3" align="center" justify="center">
    <v-container class="mx-auto">
      <div class="height-spacer"></div>
      <v-card-title class="containertext">
        <h1 id="text01pass" class="h36-medium white--text mr-2 mb-5">
          {{ $t("homepage.new-password.right.title") }}
        </h1>
        <h1 id="text01pass" class="h36-medium white--text mr-2 mb-5">
          {{ $t("homepage.new-password.right.title2") }}
        </h1>
      </v-card-title>

      <!-- RESET PASSWORD FORM -->
      <v-card-text>
        <v-form
          ref="newPasswordForm"
          v-model="newPasswordValid"
          lazy-validation
        >
          <v-text-field
            v-model="username"
            :label="
              $t('homepage.new-password.right.form.personal-data.username')
            "
            :rules="[rules.required]"
            color="#17365d"
            dark
          ></v-text-field>
          <v-text-field
            v-model="password"
            :label="
              $t('homepage.new-password.right.form.personal-data.password')
            "
            :append-icon="showPassword ? 'fas fa-eye' : 'fas fa-eye-slash'"
            :type="showPassword ? 'text' : 'password'"
            :rules="[rules.required, rules.passwordFormat]"
            validate-on-blur
            :hint="
              $t(
                'homepage.new-password.right.form.personal-data.password-format'
              )
            "
            persistent-hint
            counter
            color="#17365d"
            @click:append="showPassword = !showPassword"
            dark
          ></v-text-field>
          <v-text-field
            v-model="confirmPassword"
            :label="
              $t(
                'homepage.new-password.right.form.personal-data.confirmPassword'
              )
            "
            :append-icon="
              showConfirmPassword ? 'fas fa-eye' : 'fas fa-eye-slash'
            "
            :type="showConfirmPassword ? 'text' : 'password'"
            :rules="[
              rules.required,
              rules.passwordMatch(password, confirmPassword, 'Password')
            ]"
            validate-on-blur
            persistent-hint
            counter
            color="#17365d"
            @click:append="showConfirmPassword = !showConfirmPassword"
            dark
          ></v-text-field>
        </v-form>
      </v-card-text>

      <!-- ACTIONS BUTTONS -->
      <v-card-actions id="actionbuttons" class="pa-3">
        <v-spacer></v-spacer>
        <v-btn
          class="importantbutton"
          rounded
          :disabled="!newPasswordValid"
          @click="sendNewPasswordRequest"
        >
          <span class="font-weight-bold white--text">{{
            $t("homepage.new-password.right.form.confirmButtonLabel")
          }}</span>
        </v-btn>
      </v-card-actions>

      <v-divider dark class="my-4 mx-3"></v-divider>

      <v-card-actions id="notregcard" class="pt-4 ml-2">
        <v-row no-gutters>
          <div
            id="notregscript"
            class="v-toolbar__title my-v-toolbar__title-inherit font-weight-light white--text"
          >
            {{ $t("homepage.already-register") }}
          </div>
          <v-btn
            id="tologinbtn"
            class="ml-1 mr-0 importantbutton"
            rounded
            @click="goToLogin"
            >{{
              $t("homepage.new-password.right.form.goToLoginButtonLabel")
            }}</v-btn
          >
        </v-row>
      </v-card-actions>
    </v-container>
  </v-row>
</template>

<script>
import ValidationRules from "../../views/validationRules";

let vrules = new ValidationRules();
export default {
  data() {
    return {
      errorHeadline: "dialog.error.cardTitle",
      closeErrorButtonText: "dialog.error.closeButtonLabel",
      stepOneValid: true,
      rules: vrules,
      newPasswordValid: true,
      showPassword: false,
      showConfirmPassword: false
    };
  },
  computed: {
    errorDialog() {
      return this.$store.getters["error/errorDialog"];
    },
    username: {
      get() {
        return this.$store.getters["newPassword/username"];
      },
      set(value) {
        this.$store.commit("newPassword/SET_USERNAME", value);
      }
    },
    password: {
      get() {
        return this.$store.getters["newPassword/password"];
      },
      set(value) {
        this.$store.commit("newPassword/SET_PASSWORD", value);
      }
    },
    confirmPassword: {
      get() {
        return this.$store.getters["newPassword/confirmPassword"];
      },
      set(value) {
        this.$store.commit("newPassword/SET_CONFIRM_PASSWORD", value);
      }
    }
  },
  beforeCreate() {},
  created() {
    this.initialize();
  },
  watch: {},
  methods: {
    initialize() {
      this.$store.commit("newPassword/RESET");
      let queryParams = this.$route.params;

      if (queryParams.tempToken)
        this.$store.commit("newPassword/SET_TOKEN", queryParams.tempToken);
    },
    closeErrorDialog() {
      this.$store.commit("error/RESET");
    },
    goToLogin() {
      this.$store.dispatch("newPassword/goBackToLogin");
    },
    sendNewPasswordRequest() {
      if (this.$refs.newPasswordForm.validate()) {
        this.$store.dispatch("newPassword/sendNewPasswordRequest");
      }
    }
  }
};
</script>

<style scoped>
/*  Start Responsive screen + Specific Mobile & Tablets */

@media only screen and (min-width: 1527px) {
  .importantbutton {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-left: 0px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }

  #tologinbtn {
    margin-bottom: 18px !important;
    margin-left: 25px !important;
    padding-left: 95px !important;
    padding-right: 95px !important;
  }
}

@media screen and (max-width: 1526px) and (min-width: 1524px) {
  .importantbutton {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-left: 0px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }

  #tologinbtn {
    margin-bottom: 18px !important;
    margin-left: 25px !important;
    padding-left: 95px !important;
    padding-right: 95px !important;
  }
}

@media screen and (max-width: 1524px) and (min-width: 1513px) {
  .importantbutton {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-left: 0px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }

  #tologinbtn {
    margin-bottom: 18px !important;
    margin-left: 25px !important;
    padding-left: 95px !important;
    padding-right: 95px !important;
  }
}

@media screen and (max-width: 1512px) and (min-width: 1509px) {
  .importantbutton {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-left: 0px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }

  #tologinbtn {
    margin-bottom: 18px !important;
    margin-left: 25px !important;
    padding-left: 95px !important;
    padding-right: 95px !important;
  }
}

@media screen and (max-width: 1508px) and (min-width: 1504px) {
  .importantbutton {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-left: 0px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }

  #tologinbtn {
    margin-bottom: 18px !important;
    margin-left: 25px !important;
    padding-left: 90px !important;
    padding-right: 90px !important;
  }
}

@media screen and (max-width: 1504px) and (min-width: 1500px) {
  .importantbutton {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-left: 0px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }

  #tologinbtn {
    margin-bottom: 18px !important;
    margin-left: 25px !important;
    padding-left: 90px !important;
    padding-right: 90px !important;
  }
}

@media screen and (max-width: 1499px) and (min-width: 1494px) {
  .importantbutton {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-left: 0px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }

  #tologinbtn {
    margin-bottom: 18px !important;
    margin-left: 25px !important;
    padding-left: 90px !important;
    padding-right: 90px !important;
  }
}

@media screen and (max-width: 1494px) and (min-width: 1480px) {
  .importantbutton {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-left: 0px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }

  #tologinbtn {
    margin-bottom: 18px !important;
    margin-left: 25px !important;
    padding-left: 90px !important;
    padding-right: 90px !important;
  }
}

@media screen and (max-width: 1480px) and (min-width: 1477px) {
  .importantbutton {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-left: 0px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }

  #tologinbtn {
    margin-bottom: 18px !important;
    margin-left: 25px !important;
    padding-left: 85px !important;
    padding-right: 85px !important;
  }
}

@media screen and (max-width: 1477px) and (min-width: 1473px) {
  .importantbutton {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-left: 0px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }

  #tologinbtn {
    margin-bottom: 18px !important;
    margin-left: 25px !important;
    padding-left: 85px !important;
    padding-right: 85px !important;
  }
}

@media screen and (max-width: 1472px) and (min-width: 1448px) {
  .importantbutton {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-left: 0px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }

  #tologinbtn {
    margin-bottom: 18px !important;
    margin-left: 20px !important;
    padding-left: 80px !important;
    padding-right: 80px !important;
  }

  .containertext {
    width: 100%;
  }
}

@media screen and (max-width: 1447px) and (min-width: 1404px) {
  .importantbutton {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-left: 0px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }

  #tologinbtn {
    margin-bottom: 18px !important;
    margin-left: 20px !important;
    padding-left: 80px !important;
    padding-right: 80px !important;
  }

  .containertext {
    width: 95%;
  }
}

@media screen and (max-width: 1404px) and (min-width: 1380px) {
  .importantbutton {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-left: 0px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }

  #tologinbtn {
    margin-bottom: 18px !important;
    margin-left: 20px !important;
    padding-left: 75px !important;
    padding-right: 75px !important;
  }

  .containertext {
    width: 95%;
  }
}

@media screen and (max-width: 1380px) and (min-width: 1350px) {
  .importantbutton {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-left: 0px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }

  #tologinbtn {
    margin-bottom: 18px !important;
    margin-left: 20px !important;
    padding-left: 70px !important;
    padding-right: 70px !important;
  }

  .containertext {
    width: 95%;
  }
}

@media screen and (max-width: 1350px) and (min-width: 1300px) {
  .importantbutton {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-left: 0px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }

  #tologinbtn {
    margin-bottom: 18px !important;
    margin-left: 20px !important;
    padding-left: 60px !important;
    padding-right: 60px !important;
  }

  .containertext {
    width: 95%;
  }
}

@media screen and (max-width: 1300px) and (min-width: 1240px) {
  .importantbutton {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-left: 0px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }

  #tologinbtn {
    margin-bottom: 18px !important;
    margin-left: 16px !important;
    padding-left: 53px !important;
    padding-right: 53px !important;
  }

  .containertext {
    width: 95%;
  }
}

@media screen and (max-width: 1240px) and (min-width: 1200px) {
  .importantbutton {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-left: 0px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }

  #tologinbtn {
    margin-bottom: 18px !important;
    margin-left: 12px !important;
    padding-left: 50px !important;
    padding-right: 50px !important;
  }

  .containertext {
    width: 95%;
  }
}

@media screen and (max-width: 1200px) and (min-width: 1160px) {
  .importantbutton {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-left: 0px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }

  #tologinbtn {
    margin-bottom: 18px !important;
    margin-left: 11px !important;
    padding-left: 42px !important;
    padding-right: 42px !important;
  }

  .containertext {
    width: 95%;
  }
}

@media screen and (max-width: 1160px) and (min-width: 1100px) {
  .importantbutton {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-left: 0px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }

  #tologinbtn {
    margin-bottom: 18px !important;
    margin-left: 9px !important;
    padding-left: 32px !important;
    padding-right: 32px !important;
  }

  .containertext {
    width: 95%;
  }
}

@media screen and (max-width: 1100px) and (min-width: 1080px) {
  .importantbutton {
    padding-left: 90px !important;
    padding-right: 90px !important;
    margin-left: 0px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }

  #tologinbtn {
    margin-bottom: 18px !important;
    margin-left: 8px !important;
    padding-left: 30px !important;
    padding-right: 30px !important;
  }

  .containertext {
    width: 95%;
  }
}

@media screen and (max-width: 1080px) and (min-width: 1050px) {
  .importantbutton {
    padding-left: 90px !important;
    padding-right: 90px !important;
    margin-left: 0px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }

  #tologinbtn {
    margin-bottom: 18px !important;
    margin-left: 8px !important;
    padding-left: 27px !important;
    padding-right: 27px !important;
  }

  .containertext {
    width: 95%;
  }
}

@media screen and (max-width: 1050px) and (min-width: 1000px) {
  .importantbutton {
    padding-left: 90px !important;
    padding-right: 90px !important;
    margin-left: 0px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }

  #tologinbtn {
    margin-bottom: 18px !important;
    margin-left: 7px !important;
    padding-left: 18px !important;
    padding-right: 18px !important;
  }

  .containertext {
    width: 95%;
  }
}

@media screen and (max-width: 1000px) and (min-width: 960px) {
  .importantbutton {
    padding-left: 80px !important;
    padding-right: 80px !important;
    margin-left: 0px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }

  #tologinbtn {
    margin-bottom: 18px !important;
    margin-left: 6px !important;
    padding-left: 13px !important;
    padding-right: 13px !important;
  }

  .containertext {
    width: 95%;
  }
}

@media screen and (max-width: 959px) and (min-width: 614px) {
  .importantbutton {
    padding-left: 80px !important;
    padding-right: 80px !important;
    margin-left: 0px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }

  #tologinbtn {
    margin-bottom: 20px !important;
    margin-top: 0px !important;
    margin-left: 10px !important;
    padding-left: 150px !important;
    padding-right: 150px !important;
  }

  .containertext {
    width: 95%;
  }
}

@media screen and (max-width: 613px) and (min-width: 600px) {
  .importantbutton {
    padding-left: 80px !important;
    padding-right: 80px !important;
    margin-left: 0px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }

  #tologinbtn {
    margin-bottom: 20px !important;
    margin-top: 0px !important;
    margin-left: 10px !important;
    padding-left: 130px !important;
    padding-right: 130px !important;
  }

  .containertext {
    width: 95%;
  }
}

@media screen and (max-width: 599px) and (min-width: 573px) {
  .importantbutton {
    padding-left: 80px !important;
    padding-right: 80px !important;
    margin-left: 0px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }

  #tologinbtn {
    margin-bottom: 20px !important;
    margin-top: 0px !important;
    margin-left: 20px !important;
    padding-left: 120px !important;
    padding-right: 120px !important;
  }

  .containertext {
    width: 95%;
  }
}

@media screen and (max-width: 573px) and (min-width: 490px) {
  .importantbutton {
    padding-left: 80px !important;
    padding-right: 80px !important;
    margin-left: 0px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }

  #tologinbtn {
    margin-bottom: 20px !important;
    margin-top: 0px !important;
    margin-left: 10px !important;
    padding-left: 90px !important;
    padding-right: 90px !important;
  }

  .containertext {
    width: 100%;
  }
}

@media screen and (max-width: 489px) and (min-width: 485px) {
  .importantbutton {
    padding-left: 80px !important;
    padding-right: 80px !important;
    margin-left: 0px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }

  #tologinbtn {
    margin-bottom: 20px !important;
    margin-top: 0px !important;
    margin-left: 10px !important;
    padding-left: 90px !important;
    padding-right: 90px !important;
  }

  .containertext {
    width: 100%;
  }
}

@media screen and (max-width: 485px) and (min-width: 464px) {
  .importantbutton {
    padding-left: 155px !important;
    padding-right: 155px !important;
    margin-left: 0px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }

  #tologinbtn {
    margin-bottom: 20px !important;
    margin-top: 0px !important;
    margin-left: 10px !important;
    padding-left: 80px !important;
    padding-right: 80px !important;
  }

  .containertext {
    width: 100%;
  }
}

@media screen and (max-width: 464px) and (min-width: 444px) {
  .importantbutton {
    padding-left: 150px !important;
    padding-right: 150px !important;
    margin-left: 0px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }

  #tologinbtn {
    margin-bottom: 20px !important;
    margin-top: 0px !important;
    margin-left: 9px !important;
    padding-left: 70px !important;
    padding-right: 70px !important;
  }

  .containertext {
    width: 100%;
  }
}

@media screen and (max-width: 444px) and (min-width: 420px) {
  .importantbutton {
    padding-left: 140px !important;
    padding-right: 140px !important;
    margin-left: 0px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }

  #tologinbtn {
    margin-bottom: 20px !important;
    margin-top: 0px !important;
    margin-left: 8px !important;
    padding-left: 60px !important;
    padding-right: 60px !important;
  }

  .containertext {
    width: 100%;
  }
}

@media screen and (max-width: 420px) and (min-width: 400px) {
  .importantbutton {
    padding-left: 115px !important;
    padding-right: 115px !important;
    margin-left: 0px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }

  #tologinbtn {
    margin-bottom: 20px !important;
    margin-top: 0px !important;
    margin-left: 6px !important;
    padding-left: 45px !important;
    padding-right: 45px !important;
  }

  .containertext {
    width: 100%;
  }
}

@media screen and (max-width: 400px) and (min-width: 351px) {
  .importantbutton {
    padding-left: 100px !important;
    padding-right: 100px !important;
    margin-left: 0px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }

  #tologinbtn {
    margin-bottom: 20px !important;
    margin-top: 0px !important;
    margin-left: 5px !important;
    padding-left: 25px !important;
    padding-right: 25px !important;
  }

  .containertext {
    width: 100%;
  }
}

@media screen and (max-width: 350px) and (min-width: 320px) {
  .importantbutton {
    padding-left: 90px !important;
    padding-right: 90px !important;
    margin-left: 0px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }

  #tologinbtn {
    margin-bottom: 20px !important;
    margin-top: 20px !important;
    margin-left: 0px !important;
    padding-left: 105px !important;
    padding-right: 105px !important;
  }

  .containertext {
    width: 100%;
  }
}

@media screen and (max-width: 320px) and (min-width: 302px) {
  .importantbutton {
    padding-left: 80px !important;
    padding-right: 80px !important;
    margin-left: 0px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }

  #tologinbtn {
    margin-bottom: 20px !important;
    margin-top: 20px !important;
    margin-left: 0px !important;
    padding-left: 90px !important;
    padding-right: 90px !important;
  }

  .containertext {
    width: 90%;
  }
}

@media screen and (max-width: 301px) and (min-width: 280px) {
  .importantbutton {
    padding-left: 60px !important;
    padding-right: 60px !important;
    margin-left: 0px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }

  #tologinbtn {
    margin-bottom: 20px !important;
    margin-top: 20px !important;
    margin-left: 0px !important;
    padding-left: 70px !important;
    padding-right: 70px !important;
  }

  .containertext {
    width: 100%;
  }
}

@media screen and (max-width: 279px) and (min-width: 260px) {
  .importantbutton {
    padding-left: 55px !important;
    padding-right: 55px !important;
    margin-left: 0px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }

  #tologinbtn {
    margin-bottom: 20px !important;
    margin-top: 20px !important;
    margin-left: 0px !important;
    padding-left: 65px !important;
    padding-right: 65px !important;
  }

  .containertext {
    width: 100%;
  }
}

@media screen and (max-width: 260px) and (min-width: 250px) {
  .importantbutton {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-left: 0px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }

  #tologinbtn {
    margin-bottom: 20px !important;
    margin-top: 20px !important;
    margin-left: 0px !important;
    padding-left: 60px !important;
    padding-right: 60px !important;
  }

  .containertext {
    width: 100%;
  }
}

@media screen and (max-width: 250px) and (min-width: 240px) {
  .importantbutton {
    padding-left: 45px !important;
    padding-right: 45px !important;
    margin-left: 0px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }

  #tologinbtn {
    margin-bottom: 20px !important;
    margin-top: 20px !important;
    margin-left: 0px !important;
    padding-left: 55px !important;
    padding-right: 55px !important;
  }

  .containertext {
    width: 100%;
  }

  #text01pass {
    font-size: 30px !important;
  }
}
</style>
